import { FC } from 'react';
import classNames from 'classnames';

interface iBannerProps {
  banner: string;
}

const Banner: FC<iBannerProps> = ({ banner }) => {
  return (
    <div className={classNames('viewer-wrapper')}>
      <img src={banner} alt={banner} />
    </div>
  );
};

export default Banner;
